import gql from 'graphql-tag'

export default gql`mutation editProjectInvoice($project_id: String!, $client_id: Int!, $project_activity_budget_id: Int, $description: String!, $amount: Float!) {
    editProjectInvoice(project_id: $project_id, client_id: $client_id, project_activity_budget_id: $project_activity_budget_id, description: $description, amount: $amount) @client
}`